import React, { useEffect, useState } from "react";
import EditPagePanelComponent from "./editPagePanel.component";
import { connect, useDispatch, useSelector } from "react-redux";
import { publishNewProduct } from "../../../redux/action/products.action";
import SavingDialog from "../../dialog/savingDialog";
import { setEditorMode } from "modules/product-mgmt/redux/slice/productPage.slice";
import { resetAvailableSurveys } from "modules/survey/redux/slice";
import {canAccess} from "../../../../profile/redux/selector/profile.selector";
import {AccessRights} from "../../../../../lib/constants/accessRights";

function EditPagePanelContainer({
  children,
  enableEditorMode,
  publishNewProduct,
  hasCampaignAccess,
  hasSurveyAccess,
  hasLuckyDrawAccess,
  hasLuckyDrawV2Access,
  hasInstantLuckyDrawAccess,
  hasLoyaltyProgramAccess,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const lang = useSelector((state) => state.constant.languages);

  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetAvailableSurveys());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    enableEditorMode();
  }, [enableEditorMode]);

  const handleClose = () => {
    setIsOpen(false);
  };

  const handlePublish = () => {
    publishNewProduct();
    setIsOpen(true);
  };

  return (
    <>
      <EditPagePanelComponent
        children={children}
        handlePublish={handlePublish}
        lang={lang}
        hasCampaignAccess={hasCampaignAccess}
        hasSurveyAccess={hasSurveyAccess}
        hasLuckyDrawAccess={hasLuckyDrawAccess}
        hasLuckyDrawV2Access={hasLuckyDrawV2Access}
        hasInstantLuckyDrawAccess={hasInstantLuckyDrawAccess}
        hasLoyaltyProgramAccess={hasLoyaltyProgramAccess}
      />
      <SavingDialog isOpen={isOpen} handleClose={handleClose} />
    </>
  );
}

const mapDispatchToProps = (dispatch) => ({
  enableEditorMode: () => dispatch(setEditorMode(true)),
  publishNewProduct: () => dispatch(publishNewProduct()),
});

const mapStateToProps = (state) => ({
  hasCampaignAccess:
    canAccess(state, AccessRights.Survey.LISTING_READ) ||
    canAccess(state, AccessRights.Campaign.LUCKY_DRAW_READ) ||
    canAccess(state, AccessRights.CampaignV2.LUCKY_DRAW_LIST_READ) ||
    canAccess(state, AccessRights.Campaign.INSTANT_LUCKY_DRAW_READ) ||
    canAccess(state, AccessRights.LoyaltyProgram.LOYALTY_POINT_READ),
  hasSurveyAccess: canAccess(state, AccessRights.Survey.LISTING_READ),
  hasLuckyDrawAccess: canAccess(state, AccessRights.Campaign.LUCKY_DRAW_READ),
  hasLuckyDrawV2Access: canAccess(state, AccessRights.CampaignV2.LUCKY_DRAW_LIST_READ),
  hasInstantLuckyDrawAccess: canAccess(state, AccessRights.Campaign.INSTANT_LUCKY_DRAW_READ),
  hasLoyaltyProgramAccess: canAccess(state, AccessRights.LoyaltyProgram.LOYALTY_POINT_READ),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditPagePanelContainer);
